export default __webpack_public_path__ + "static/media/clinor.d6af4a25.png";